import { render, staticRenderFns } from "./PartnerAgency.vue?vue&type=template&id=8ce3fff6&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./PartnerAgency.vue?vue&type=script&lang=ts"
export * from "./PartnerAgency.vue?vue&type=script&lang=ts"
import style0 from "./PartnerAgency.vue?vue&type=style&index=0&id=8ce3fff6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce3fff6",
  null
  
)

export default component.exports